import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { PlanAdoptionRoutes } from '../../routes';
import { LayDcPlanAdoptionWizard } from './lay-dc-plan-adoption-wizard';

export class LayDcQuestionsWizard extends LayDcPlanAdoptionWizard {    

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();

        return {
            ...content,
            gpsType: GpsType.LayDcAdoptionQuestions,
            pageTitle: institutionSettings?.qccoLayRsvpTitle,
            PageDescription: institutionSettings?.qccoLayDCDescription,
            submitLabel: institutionSettings?.qccoQuestionSubmitLabel,
            cancelLabel: institutionSettings?.qccoQuestionCancelLabel,
        };
    }    


    getNextStepUrl() {
        return `${this.wizardOptions?.featureRootPath}${PlanAdoptionRoutes.AdoptionDetails}`;        
    }
}